import React, { FC, useCallback, useState } from "react";
import { ReactComponent as EducationIcon } from "../../../../assets/svg/program-type.svg";
import { ReactComponent as Branch } from "../../../../assets/svg/branch-location.svg";
import { ReactComponent as ArrowRight } from "../../../../assets/svg/arrow-right.svg";
import { ReactComponent as Location } from "../../../../assets/svg/location-map.svg";
import { AdapterLink } from "../../../../components/Adopter";
import { Routes } from "../../../../constants/routes";
import { urlReplacer } from "../../../../utils";
import { usePrivateClassCardStyles } from "./usePrivateClassCardStyles";
import { CardField } from "../../../../components/CardField/CardField";
import { IPrivateClassCardFrontEndModel } from "../../cardsPageContext";
import { ExpandedBio } from "./ExpandedBio";
import { ExpandedEducation } from "./ExpandedEducation";

interface IPrivateClassCardProps {
  privateClass: IPrivateClassCardFrontEndModel;
}

export const PrivateClassCard: FC<IPrivateClassCardProps> = ({
  privateClass,
}) => {
  const classes = usePrivateClassCardStyles();

  const [expandedCardFieldId, setExpandedCardFieldId] = useState(null);
  const expandHandler = useCallback((id) => {
    setExpandedCardFieldId((prev) => {
      return prev === id ? null : id;
    });
  }, []);

  const closeCard = () => setExpandedCardFieldId(null);

  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <img
          alt={"Teacher Image"}
          src={privateClass.teacher.profilePicture}
          className={classes.teacherImage}
          width={60}
          height={60}
        />
        <div className={classes.headerInfoContainer}>
          <div className={classes.headerInfoSubContainer1}>
            <div className={classes.teacherName}>
              {privateClass.teacher.name}
            </div>
            <div className={classes.teachingLanguage}>
              <span className={classes.bold}>
                {privateClass.teachingLanguage}
              </span>{" "}
              <span className={classes.smallText}>(teaching language)</span>
            </div>
          </div>
          <div className={classes.headerInfoSubContainer2}>
            <div className={classes.subjectName}>
              {privateClass.subjectName}
            </div>
          </div>
        </div>
      </div>
      <div className={classes.content}>
        <CardField
          id={1}
          Icon={Branch}
          title={"Bio"}
          className={classes.bioField}
          PreviewContent={() => <ExpandedBio bio={privateClass.teacher.bio} />}
          ExpandedContent={() => <ExpandedBio bio={privateClass.teacher.bio} />}
          onExpand={expandHandler}
          onClickAway={closeCard}
          isExpanded={expandedCardFieldId === 1}
        />
        <CardField
          id={2}
          Icon={EducationIcon}
          title={"Education"}
          className={classes.bioField}
          PreviewContent={() => (
            <ExpandedEducation education={privateClass.teacher.education} />
          )}
          ExpandedContent={() => (
            <ExpandedEducation education={privateClass.teacher.education} />
          )}
          onExpand={expandHandler}
          onClickAway={closeCard}
          isExpanded={expandedCardFieldId === 2}
        />
        {/* <CardField
          id={CardFieldType.RequiredDocuments}
          Icon={RequiredDocumentsInsideCircle}
          title={"Required Documents"}
          PreviewContent={privateClass.capitalizedRequiredDocuments}
          ExpandedContent={() => (
            <ExpandedRequiredDocuments
              reqDocs={privateClass.capitalizedRequiredDocuments}
            />
          )}
          onExpand={expandHandler}
          onClickAway={closeCard}
          isExpanded={expandedCardFieldId === CardFieldType.RequiredDocuments}
          isMasked={false}
        />
        <CardField
          id={CardFieldType.HousingType}
          Icon={HousingType}
          title={"Housing Types"}
          PreviewContent={privateClass.housingTypeNames}
          ExpandedContent={() => (
            <ExpandedHousingTypes housingTypes={privateClass.housingTypeNames} />
          )}
          onExpand={expandHandler}
          onClickAway={closeCard}
          isExpanded={expandedCardFieldId === CardFieldType.HousingType}
        />
        <CardField
          Icon={OtherFees}
          title={"Other Fees"}
          PreviewContent={[privateClass.otherFeesTotal]}
          isMasked={privateClass.isMasked}
        />
        <CardField
          Icon={Scholarship}
          title={"Discount"}
          PreviewContent={[privateClass.discount]}
          isMasked={privateClass.isMasked}
        /> */}
      </div>
      <div className={classes.footer}>
        <div className={classes.addressContainer}>
          <Location className={classes.locationIcon} />
          <span className={classes.address}>
            {privateClass.teacher.country}
          </span>
        </div>
        <div>
          <AdapterLink
            to={urlReplacer(Routes.VIEW_PRIVATE_CLASS, { id: privateClass.id })}
            className={classes.link}
          >
            <span>View More &nbsp;</span>
            <ArrowRight className={classes.arrowRight} />
          </AdapterLink>
        </div>
      </div>
    </div>
  );
};
